.item {
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  transition: transform 0.1s ease-in-out;
  color: var(--mantine-color-dark-5);
}

.item:not(:last-child) {
  border-bottom: 1px solid var(--mantine-color-gray-2);
}

.item:hover {
  background-color: var(--mantine-color-gray-1);
  transform: scale(1.01);
  color: var(--mantine-color-dark-9);
}
